export const textToClassName = (text) => {
    if (!text) {
        return ''
    }
    return text.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
};

String.prototype.interpolate = function (params) {
    return this.replace(/\$\{(\w+)\}/g, (match, p1) => {
        const value = params[p1];
        // Check if the value is a string before interpolating
        return typeof value === 'string' ? value : match;
    });
};

export const getEnvVariable = (key, isRequired = true) => {
    const actualKey = `REACT_APP_${key}`
    if (!process.env[actualKey]) {
        if (isRequired) {
            console.error(`Please configure ${actualKey} in environment`)
        }
        else {
            console.warn(`Please configure ${actualKey} in environment`)
        }
        return ''
    }
    return process.env[actualKey]
}

export const arrayIntersection = (array1, array2) => array1.filter(value => array2.includes(value))

export const getHistoryState = () => history?.state?.usr

export const isObjectEmpty = (obj) => {
  if (obj == null) return true;
  return Object.keys(obj).length === 0;
};

export const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    return sortedArr1.every((element, index) => element === sortedArr2[index]);
}

const AVATAR_COLORS = [
  '#1890ff',
  '#52c41a',
  '#fa8c16',
  '#722ed1',
  '#13c2c2',
  '#eb2f96',
  '#fa541c',
  '#2f54eb',
];

export const getAvatarColor = (name = '') => {
  if (!name || typeof name !== 'string') return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

export const getInitials = (name, email = '') => {
  const str = (name || email?.split('@')[0] || '').trim();
  if (!str) return 'U';
  const words = str.split(/\s+/).filter(Boolean);
  if (words.length > 1) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  if (str.length === 1) return str.toUpperCase();
  return (str[0] + str[str.length - 1]).toUpperCase();
};